export enum ExceptionTypes {
    ACH = 'ach-exceptions',
    CHECK = 'check-exceptions',
}
